import type { CommissionStatementAnnualDeclarationDto } from 'korint-sdk';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../../../components/ui/card';
import { AnnualDeclarationRow } from './AnnualDeclarationRow';

export function AnnualDeclarationsCard({
  brokerageFirmId,
  declarations,
}: {
  brokerageFirmId: string;
  declarations: CommissionStatementAnnualDeclarationDto[];
}) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-primary">{t('commissions.annual.title')}</CardTitle>
        <CardDescription>{t('commissions.annual.description')}</CardDescription>
      </CardHeader>
      <CardContent className="divide-y">
        {declarations.map(declaration => (
          <AnnualDeclarationRow
            key={declaration.year}
            brokerageFirmId={brokerageFirmId}
            declaration={declaration}
          />
        ))}
      </CardContent>
    </Card>
  );
}
